import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TargetIcon, TrendingDown } from "../../../../images/icons/icons";

const WeightProgress = ({ progressCards }) => {
  const { memberWeight, memberWeightError, memberWeightLoading } = useSelector(
    (state) => state.prospects
  );

  const [weightStats, setWeightStats] = useState({});
  const stats = weightStats?.weight_stats;
  const bmiStats = weightStats?.bmi_stats;
  const bcaStats = weightStats?.bca_stats;

  useEffect(() => {
    if (
      !memberWeightError &&
      !memberWeightLoading &&
      memberWeight?.status &&
      memberWeight?.data
    ) {
      setWeightStats(memberWeight.data?.[0]);
    } else {
      setWeightStats({});
    }
  }, [memberWeight, memberWeightError, memberWeightLoading]);

  return (
    <div className="tme-analysis-chart-progress-section">
      <div className="tme-analysis-chart-progress-card">
        <div className="tme-analysis-chart-progress-header">
          <h3 className="tme-analysis-chart-progress-title">Weight Progress</h3>
          <div className="tme-analysis-chart-progress-icon">
            <TrendingDown />
          </div>
        </div>
        <div className="tme-analysis-chart-progress-items">
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Start</span>
            <span className="tme-analysis-chart-progress-value">
              {`${parseInt(stats?.start || 0).toFixed(2)} kg`}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Current</span>
            <span className="tme-analysis-chart-progress-value">
              {`${parseInt(stats?.current || 0).toFixed(2)} kg`}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Change</span>
            <span
              className={`tme-analysis-chart-progress-value ${
                stats?.change > 0
                  ? "tme-analysis-chart-change-positive"
                  : "tme-analysis-chart-change-neutral"
              }`}
            >
              {stats?.change > 0
                ? `+${parseInt(stats.change || 0).toFixed(2)}`
                : parseInt(stats?.change || 0).toFixed(2)}{" "}
              Kg
            </span>
          </div>
        </div>
      </div>

      <div className="tme-analysis-chart-progress-card">
        <div className="tme-analysis-chart-progress-header">
          <h3 className="tme-analysis-chart-progress-title">BMI Progress</h3>
          <div className="tme-analysis-chart-progress-icon">
            <TrendingDown />
          </div>
        </div>
        <div className="tme-analysis-chart-progress-items">
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Start</span>
            <span className="tme-analysis-chart-progress-value">
              {parseInt(bmiStats?.start || 0).toFixed(2) || "-"}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Current</span>
            <span className="tme-analysis-chart-progress-value">
              {parseInt(bmiStats?.current || 0).toFixed(2) || "-"}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Change</span>
            <span
              className={`tme-analysis-chart-progress-value ${
                bmiStats?.change > 0
                  ? "tme-analysis-chart-change-positive"
                  : "tme-analysis-chart-change-neutral"
              }`}
            >
              {bmiStats?.change > 0
                ? `+${parseInt(bmiStats.change || 0).toFixed(2)}`
                : parseInt(bmiStats?.change || 0).toFixed(2)}
            </span>
          </div>
        </div>
      </div>

      {/* <div className="tme-analysis-chart-progress-card">
        <div className="tme-analysis-chart-progress-header">
          <h3 className="tme-analysis-chart-progress-title">BCA Progress</h3>
          <div className="tme-analysis-chart-progress-icon">
            <TargetIcon color="#3b82f6" />,
          </div>
        </div>
        <div className="tme-analysis-chart-progress-items">
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">
              Start (BCA1)
            </span>
            <span className="tme-analysis-chart-progress-value">
              {parseInt(bcaStats?.start || 0).toFixed(2) || "-"}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">
              Latest (BCA3)
            </span>
            <span className="tme-analysis-chart-progress-value">
              {parseInt(bcaStats?.latest || 0).toFixed(2) || "-"}
            </span>
          </div>
          <div className="tme-analysis-chart-progress-item">
            <span className="tme-analysis-chart-progress-label">Change</span>
            <span
              className={`tme-analysis-chart-progress-value ${
                bcaStats?.change > 0
                  ? "tme-analysis-chart-change-positive"
                  : "tme-analysis-chart-change-neutral"
              }`}
            >
              {bcaStats?.change > 0
                ? `+${parseInt(bcaStats.change || 0).toFixed(2)}`
                : parseInt(bcaStats?.change || 0).toFixed(2)}
            </span>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default WeightProgress;
